import { DateTime, Interval } from 'luxon'

const name = 'date_iso'

const validator = (value, params) => {
  let date = DateTime.fromISO(value)

  let start = params && params.min ? DateTime.fromISO(params.min) : null
  let end = params && params.max ? DateTime.fromISO(params.max) : null

  let interval = start && end
    ? Interval.fromDateTimes(start, end)
    : null

  if (interval === null && start) {
    // First day of after is inclusive
    interval = Interval.after(start, { years: 200 })
  }

  if (interval === null && end) {
    // First day of before is Not inclusive, so add one day
    interval = Interval.before(end.plus({ days: 1 }), { years: 200 })
  }

  return (interval && interval.contains(date)) || interval === null
}

export default {
  name,
  validator
}
